import { useLogout } from '@/core/hooks';
import { SpinnerIcon } from '@/components/icons';

export default function Logout() {
  const { isFetched } = useLogout();

  if (isFetched) {
    window.location.href = process.env.NEXT_PUBLIC_ACCOUNTS_URL as string;
  }
  return (
    <div className="flex flex-col h-content justify-center items-center space-y-3">
      <SpinnerIcon className="animate-spin w-8 h-8" />
      <div className="w-full text-center text-xl">Logging Out...</div>
    </div>
  );
}
